import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const steps = [
  {
    number: "01",
    title: "Upload Documents",
    description: "Start by uploading your books, syllabi, and reference papers—all at once.",
  },
  {
    number: "02",
    title: "Interact with Curve Ai",
    description: "Chat with Curve Ai to get instant explanations, quiz yourself, or ask for summaries and study plans.",
  },
  {
    number: "03",
    title: "Generate Outputs",
    description: "Create mock exams, study guides, key topics, and exam predictions tailored to your needs.",
  },
  {
    number: "04",
    title: "Iterate & Refine",
    description: "Keep chatting, upload more files, and refine your study resources until you're ready for success!",
  },
];

const HowItWorks = () => {
  const navigate = useNavigate();
  return (
    <section id="how-it-works" className="py-12 sm:py-16 md:py-20">
      <div className="container px-4 sm:px-6 md:px-8 mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">How Curve Ai Works</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
            Upload, chat, generate, and refine—Curve Ai is your interactive study partner from start to finish.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, idx) => (
            <div
              key={step.number}
              className="text-center flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay={idx * 120}
            >
              <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary/10 text-primary font-bold text-lg sm:text-xl mb-4 sm:mb-6">
                {step.number}
              </div>
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3">{step.title}</h3>
              <p className="text-gray-600 text-sm sm:text-base">{step.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10 sm:mt-16">
          <Button size="lg" className="bg-primary hover:bg-primary/90 w-full sm:w-auto" onClick={() => navigate("/app") }>
            Get Started Now
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 